












































































































































































































	import { Component } from "../../../Infrastructure/CorBase/CoreBase";
	import SettingDetailBase from "./SettingDetailBase";
	//import { BaseTLDetailComponent, Component, SettingService, RightHelper, AxiosResponse } from "../../../Infrastructure/Core";
	//import { Component, BaseTLDetailComponent, Prop, SettingFilter, SettingService, Vuex, Vue, AxiosResponse, RightHelper } from "../../../Infrastructure/CorBase/CoreBase";
	@Component
	export default class SettingDetail extends SettingDetailBase {
		//VaPTODO - sdilenou funkcionalitu co jsem rozkopiroval i do SettingDetail.vue idealne zkusit nejak presunout do spolecne tridy, mixinu nebo nejak jinak implementovat pouze jednou
		//        - prime dedeni neni mozne, jelikoz list a detail musi mit jineho predka ;-(
		

		created() {
			this.returnRoute = String(this.$router.currentRoute.query.goBack);
			this.setIsGlobalSetting();
			this.createdBase();
			this.initializeRightsLocal();
			super.setMainDescription('setting.new', 'setting.detail');
            this.mainDataChanged = false;
		}

        preventRefresh(event: any) {
            if (this.$store.state.askBeforeCancelEditing === true && (this.mainDataChanged || this.mainDataChangedSub)) {
                event.preventDefault(); event.returnValue = "";
            }
        }
        beforeMount() {
            window.addEventListener("beforeunload", this.preventRefresh);
        }

        beforeDestroy() {
            window.removeEventListener("beforeunload", this.preventRefresh);
            this.$store.commit("formIsInEditMode", false);
            this.$store.commit("mainDataChanged", false);
        }

		initializeRightsLocal() {
			if (this.formData.isSettingGlobal) {
				super.initializeRights(undefined, undefined, 'COR_Setting_Global', 'COR_Setting_Global');
			}
			else if (this.formData.isSettingTenant) {
				super.initializeRights(undefined, undefined, 'COR_Setting_Tenant', 'COR_Setting_Tenant');
			}
			else {
				super.initializeRights(undefined, undefined, 'COR_Setting_User', 'COR_Setting_User');
			}
		}


		mounted() {
			super.mounted();
		};

		
		validate() {
			return this.validateBase();
		}

		isCorrectValue(value: any) {
			this.isCorrectValueBase(value);
		}


	}
